import type { ILocation } from 'shared/types/locations';
import type { IApplicationState } from 'shared/types/redux';

export function locationsListSelector(state: IApplicationState): ILocation[] {
  return state.locations.list;
}
